import React from 'react';
import { Helmet } from 'react-helmet-async';
import { BRAND_NAME, DEFAULT_OG_IMAGE, absoluteUrl } from '../seo';

function WhyActivity() {
  const pageUrl = absoluteUrl('/why-activity');
  const pageTitle = 'Why Activity-Based Breathwork';
  const pageDescription =
    'Learn why activity-based breathwork courses can improve consistency, performance, and recovery more effectively than generic routines.';

  return (
    <section className="basic-page">
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link rel="canonical" href={pageUrl} />
        <meta property="og:title" content={`${pageTitle} | ${BRAND_NAME}`} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={DEFAULT_OG_IMAGE} />
        <meta name="twitter:title" content={`${pageTitle} | ${BRAND_NAME}`} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />
      </Helmet>
      <h1>Why Activity-Based Breathwork</h1>
      <p>
        Generic breathing advice is helpful, but your breathing needs during a workout, high-pressure moment, or
        recovery session are different.
      </p>
      <h2>More relevant sessions</h2>
      <p>Apex Breath routines are structured around use-cases, not random timers.</p>
      <h2>Better consistency</h2>
      <p>Short sessions and clear goals make it easier to practice daily and actually see progress.</p>
      <h2>Performance + calm</h2>
      <p>The app helps you switch between output mode and reset mode with simple guided pacing.</p>
    </section>
  );
}

export default WhyActivity;
